module.exports = __webpack_public_path__ + "img/pic_404@2x.2df3ee96.png";